import React from 'react'
import cx from 'classnames'
import { Icon } from '@manychat/manyui'

import { ToolsPopovers } from 'components/MCTextEditor/toolbar/constants'
import { IToolHandler } from 'components/MCTextEditor/types'

import { Tools } from '../../toolbar/toolbarInterfaces'

import ToolbarItem from './ToolbarItem'

const ToolsAnchors: Record<string, (isSelected: boolean) => React.ReactElement> = {
  [Tools.emoji]: (isSelected) => (
    <Icon.Smile size={24} className={cx('pointer', isSelected && 'text-primary')} />
  ),
  [Tools.vars]: (isSelected) => (
    <Icon.Data size={24} className={cx('pointer', isSelected && 'text-primary')} />
  ),
  [Tools.smartLinks]: (isSelected) => (
    <Icon.Link size={24} className={cx('pointer', isSelected && 'text-primary')} />
  ),
}

const ToggleTool = ({
  tool,
  selectedTool,
  onInsert,
  onSelect,
  className = '',
}: {
  tool: Tools
  selectedTool: string | null
  onInsert: IToolHandler
  onSelect: (tool: string | null) => void
  className?: string
}) => {
  const ToolPopover = ToolsPopovers[tool]
  const renderAnchor = ToolsAnchors[tool]
  if (!ToolPopover || !renderAnchor) {
    return null
  }

  return (
    <ToolbarItem
      isSelected={selectedTool === tool}
      popoverOpen={selectedTool === tool}
      className={className}
      renderAnchor={renderAnchor}
      renderPopover={() => <ToolPopover onSelect={onInsert} />}
      onPopoverRequestClose={() => void onSelect(null)}
      onClick={() => void onSelect(tool)}
    />
  )
}

export default ToggleTool
